<script lang="ts">
    import { APIHelper } from "../../code/APIHelper";
    import DBG from "../../code/DBG";

    import Helpers from "../../code/Helpers";
    import ContactSupport from "../Generic/ContactSupport.svelte";

    let status = "&nbsp;";

    let user: string;
    let password: string;

    function validateFields(){
        if(!user || !password){
            status = "ERROR: both email and password are required";
            return false;
        }
        if(!Helpers.EmailCorrect(user)){
            status = "ERROR: email address incorrect";
            return false;
        }
        if(password.length < 8){
            status = "ERROR: password must be at least 8 characters long";
            return false;
        }
        return true;
    }

    function submit() {
        status = "Sending...";
        if(!validateFields()){
            return;
        }
        Helpers.HashString(password).then((pass) => {
            APIHelper.callApiEntry({
                op: "register",
                user: user,
                passHash: pass,
            })
                .then((res) => {
                    DBG.log("IdentityRegister - submit - register", res);
                    status = "DONE";
                })
                .catch((reason) => {
                    DBG.log(
                        "IdentityRegister - submit - register failed",
                        reason
                    );
                    status = "FAIL";
                });
        });
    }
</script>

<div>
    {#if status == "DONE"}
        <div class="completed">
            <i class="fa fa-check" /> Excellent, you've completed the registration.
        </div>
    {:else if status == "FAIL"}
        <div class="failed">
            <p>
                <i class="fa fa-times-circle" /> It looks like a licence is not
                assigned to user: {user}. Please try again later.
            </p>
            <p>
                <ContactSupport />
            </p>
        </div>
    {:else}
        <div class="info">Let us know how you will log into TLMSP</div>
        <div class="form-floating mb-3">
            <input
                type="text"
                class="form-control"
                id="userEmail"
                placeholder="John Doe"
                bind:value={user}
            /> <label for="form">Email</label>
        </div>
        <div class="form-floating mb-3">
            <input
                type="password"
                class="form-control"
                id="userPassword"
                placeholder="password"
                bind:value={password}
            /> <label for="form">Password</label>
        </div>

        <button type="button" class="btn btn-primary" on:click={submit}
            >Submit</button
        >
        <div class="status">
            {@html status}
        </div>
    {/if}
</div>

<style>
    .info {
        margin-bottom: 1rem;
    }
    .completed i {
        color: green;
    }
    .failed i {
        color: #ec008c;
    }
</style>
